import {useState, useEffect, createContext} from 'react'
import jwt_decode from "jwt-decode"
import {useNavigate} from 'react-router-dom'


const AuthContext = createContext<any>(null)
export default AuthContext


export function AuthProvider(props: any) {

    const serverIP = 'https://api.icefeeds.com'    // const serverIP = 'http://127.0.0.1:8000'
    const {children} = props
    const navigate = useNavigate()

    let locStorData = localStorage.getItem('authTokens')
    let locStorUser = locStorData ? jwt_decode(JSON.parse(locStorData).access) : null

    let [authTokens, setAuthTokens] = useState<any>(() => locStorData ? JSON.parse(locStorData) : null)
    let [user, setUser] = useState<any>(() => locStorUser)
    let [loading, setLoading] = useState<boolean>(false)


    let loginUser = async (event: any) => {
        event.preventDefault()
        // console.log('Form submitted')

        let response: any = await fetch(`${serverIP}/jwt/token/`,
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    'username': event.target.username.value,
                    'password': event.target.password.value
                })
            })
        let data: any = await response.json()

        if (response.status === 200) {

            let decoded: any = jwt_decode(data.access)
            // console.log('Decoded data:', decoded.username)

            setAuthTokens(data)
            setUser(decoded)
            localStorage.setItem('authTokens', JSON.stringify(data))
            navigate('/')

        } else {
            alert('Something went wrong!')
        }

    }

    let logoutUser = () => {
        setAuthTokens(null)
        setUser(null)
        localStorage.removeItem('authTokens')
        localStorage.removeItem('userPermissions')
        navigate('/login')
    }


    let updateToken = async () => {
        let response: any = await fetch(`${serverIP}/jwt/token/refresh/`,
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    'refresh': authTokens?.refresh
                })
            })
        let data: any = await response.json()

        if (response.status === 200) {
            let decoded: any = jwt_decode(data.access)
            setAuthTokens(data)
            setUser(decoded)
            localStorage.setItem('authTokens', JSON.stringify(data))
        } else {
            logoutUser()
        }

        if (loading) {
            setLoading(true)
        }
    }

    useEffect(() => {

        if (loading) {
            updateToken().then()
        }

        let tokenTime = 1000 * 60 * 478    // 8 hrs without 2 minutes

        let interval = setInterval(() => {
            if (authTokens) {
                updateToken()
            }
            }, tokenTime)
        return () => clearInterval(interval)

    }, [authTokens, loading])


    //  User Permissions
    let locStorPermissions = localStorage.getItem('userPermissions')
    const [userPermisions, setUserPermissions] = useState<any>(() => locStorPermissions ? JSON.parse(locStorPermissions) : {})
    // console.log(userPermisions)

    useEffect(() => {
        if (user && authTokens.access) {
            getUserPermissions()
        }
    }, [authTokens])

    let getUserPermissions = async () => {
        let response = await fetch(`${serverIP}/getuserpermissions/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access),
            },
            body: JSON.stringify({login: user.username})    // user = {'token_type': 'access', 'exp': 1742082268, 'iat': 1742067868, 'jti': '5e149475949943e79b78f53ad74cb1eb', 'user_id': 1, 'username': 'ilya'}
        })
        let permData = await response.json()

        if (response.status === 200) {
            setUserPermissions(permData)
            localStorage.setItem('userPermissions', JSON.stringify(permData))
        }
    }

    // Forming contextData
    let contextData: any = {
        user: user,
        authTokens: authTokens,
        loginUser: loginUser,
        logoutUser: logoutUser,
        serverIP: serverIP,
        userPermissions: userPermisions
    }

    // console.log('contextData', contextData)

    return (
        <AuthContext.Provider value={contextData}>
            {loading ? null : children}
        </AuthContext.Provider>
    )
}
